import {AbstractModel} from '../abstract-model';
import {Offer} from '../offer';

export class ClickReport extends AbstractModel {
  clickid: number | null = null;
  offer: Offer | null = null;
  date: string = '';
  ip: string = '';
  subid: string = '';
  tc1: string = '';
  tc2: string = '';
  tc3: string = '';
  tc4: string = '';

  getDate(): Date {
    return new Date(this.date);
  }

  override toString(): string {
    return this.date;
  }
}
